import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vue-good-table-next/dist/vue-good-table-next.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

const app = createApp(App);
app.use(store);
app.use(router);
app.mount("#app");
